import { Button, Dropdown } from "flowbite-react";
import { IoArrowForward, IoPricetagOutline } from "react-icons/io5";
import { Swiper, SwiperSlide } from 'swiper/react';
import { getIonIcon } from "../../commons/IonIconList";
import 'swiper/css';
import ColoredBackImage from "../../components/ColoredBackImage";
import EventPageItem from "./EventPageItem";
import { useEffect, useState } from "react";
import EventsService from "../../services/EventsService";
import { Link, useNavigate } from "react-router-dom";
import Helpers from "../../utils/Helpers";

const eventCategories = [
    { label: 'Arts & théatre', color: 'bg-purple-700', icon: 'color-palette-outline' },
    { label: 'Concerts', color: 'bg-yellow-500', icon: 'musical-notes-outline' },
    { label: 'Familles', color: 'bg-red-500', icon: 'fast-food-outline' },
    { label: 'Cinema', color: 'bg-blue-500', icon: 'film-outline' },
    { label: 'Sports', color: 'bg-green-500', icon: 'bicycle-outline' },
];

const EventsPage = () => {
	const navigate = useNavigate();
	const [events, setEvents] = useState([]);
	const [categories, setCategories] = useState([]);
	const [loading, setLoading] = useState(null);
	const [searchParams, setSearchParams] = useState({});

	const getEvents = () => {
		setLoading('get-events');

		Promise.all([
			EventsService.searchEvent(),
			EventsService.getCategories()
		])
		.then(response => {
			setEvents(response[0].events);
			setCategories(response[1].categories);
		})
		.catch(err => console.log(err))
		.finally(() => setLoading(null));
	};

	const goToSearch = () => {
		navigate(`/events/search?${Helpers.objToUrlParams(searchParams, true)}`);
	};

	useEffect(() => {
		getEvents();
	}, []);

    return (
        <>
        {/* HERO SECTION */}
        <section className={`bg-gray-900 min-h-[500px]`}>
            <div className={`max-w-screen-2xl mx-auto px-10 md:px-20`}>
                <div className={`min-h-[500px] pt-10 md:pt-28 pb-10`}>
                    {/* TEXT */}
                    <div className={``}>
                        <h4 className={`hidden md:block text-gray-500 text-base mb-3`}>TOUT COMMENCE PAR ICI</h4>
                        <h1 className={`text-white font-semibold text-5xl md:text-6xl`}>
                            Participez à <span className={`text-orange-500 font-bold`}>des fêtes</span>
                        </h1>
                        <h1 className={`text-white font-semibold text-5xl md:text-6xl mt-2`}>autour de vous.</h1>
                    </div>
                    {/* FILTERS */}
                    <div className={`max-w-4xl bg-white min-h-[110px] mt-14 rounded-md flex flex-col md:flex-row gap-4 md:gap-16 p-5 md:p-7`}>
                        <div className={`p-3 md:p-0 border md:border-0 border-neutral-100 rounded-md`}>
                            <span className={`text-base text-gray-500 block`}>Quoi ?</span>
                            <Dropdown
                                theme={{ floating: { content: 'w-[200px]' }}}
                                renderTrigger={() => (
                                    <button className={`text-lg text-gray-700 cursor-pointer text-left`}>
										{
											searchParams.category
												? categories.find(x => x.id === searchParams.category).label
												: 'Selectionnez une catégorie'
										}
									</button>
                                )}
                            >
								{categories.map(item => (
									<Dropdown.Item
										key={item.id}
										onClick={() => setSearchParams(state => ({...state, category: item.id}))}
									>{item.label}</Dropdown.Item>
								))}
                            </Dropdown>
                            
                        </div>
                        <div className={`p-3 md:p-0 border md:border-0 border-neutral-100 rounded-md`}>
                            <span className={`text-base text-gray-500 block`}>Où ?</span>
                            <Dropdown
                                theme={{ floating: { content: 'w-[200px]' }}}
                                renderTrigger={() => (
                                    <span className={`text-lg text-gray-700 cursor-pointer`}>Choisir une ville</span>
                                )}
                            >
                                <Dropdown.Item>Abidjan</Dropdown.Item>
                                <Dropdown.Item>Yamoussoukro</Dropdown.Item>
                                <Dropdown.Item>Bouaké</Dropdown.Item>
                                <Dropdown.Item>San-Pédro</Dropdown.Item>
                                <Dropdown.Item>Daloa</Dropdown.Item>
                            </Dropdown>
                            
                        </div>
                        <div className={`p-3 md:p-0 border md:border-0 border-neutral-100 rounded-md`}>
                            <span className={`text-base text-gray-500 block`}>Quand ?</span>
                            <input type="date" id="date-pick" className={`p-0 outline-none mt-1 border-0 text-gray-700`} />
                        </div>
                        <div className="self-center ml-auto w-full md:w-auto">
                            <Button
								onClick={() => goToSearch()}
								className={`bg-orange-500 hover:!bg-orange-600 h-12 w-full md:w-auto`}
							>CHERCHER</Button>
                        </div>
                    </div>
                    {/* CATEGORIES */}
                    <div className={`mt-20`}>
                        <h4 className={`text-gray-500 text-base mb-1`}>OU POUR ALLER PLUS VITE</h4>
                        <h2 className={`text-4xl font-bold text-gray-200`}>Laissez vous guider</h2>
                        <div className={`flex mt-10 gap-7`}>
                            <Swiper
                                slidesPerView={1.5}
                                spaceBetween={25}
                                breakpoints={{
                                    600: { slidesPerView: 2.5 },
                                    940: { slidesPerView: 3.5 },
                                    1150: { slidesPerView: 4.5 }
                                }}
                            >
                                {eventCategories.map(item => {
                                    const Icon = getIonIcon(item.icon) || IoPricetagOutline;
                                    return (
                                        <SwiperSlide key={item.color}>
                                            <div className={`flex-1 h-64 rounded-md flex flex-col items-center justify-center bg-gray-950`}>
                                                <div className={`${item.color} text-white p-5 rounded-2xl`}>
                                                    <Icon size={35} />
                                                </div>
                                                <span className={`block text-2xl font-bold text-gray-300 mt-4 text-center`}>{item.label}</span>
                                                <span className={`block text-base font-thin text-gray-500 text-center`}>Voir les évènements</span>
                                            </div>
                                        </SwiperSlide>
                                    );
                                })}
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className={`py-20`}>
            <div className={`max-w-screen-2xl mx-auto px-10 md:px-20`}>
                <div className={`flex items-center`}>
                    <div className={``}>
                        <h4 className={`text-gray-500 text-xs md:text-sm uppercase`}>Actuellement</h4>
                        <h1 className={`text-gray-800 text-3xl md:text-5xl font-bold`}>En cours et à venir</h1>
                    </div>
                    <Button
						className={`bg-orange-200 hover:!bg-orange-300 text-orange-500 h-10 md:h-12 px-1 ml-auto shrink-0`}
						onClick={() => navigate('/events/search')}
					>
                        Voir tout <IoArrowForward size={18} className={`ml-2`} />
                    </Button>
                </div>
                <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-12 gap-8`}>
					{events.map((item, idx) => (
						<Link to={`/events/${item.id}`} className={`${idx === 0 && 'md:col-span-2'}`} key={item.id}>
							<EventPageItem item={item} />
						</Link>
					))}
				</div>
            </div>
        </section>
        </>
    );
};

export default EventsPage;